msgid ""
msgstr ""
"POT-Creation-Date: 2026-01-18 16:02+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: pkg.totalPriceMonthly
#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "{0} €/mo"
msgstr "{0} €/mes"

#. placeholder {0}: warrantyStats.active
#: src/modules/maintenance/Summary.tsx
msgid "{0} active"
msgstr "{0} activas"

#. placeholder {0}: formatDate(visitDate)
#. placeholder {1}: visitDate.toLocaleTimeString( 'fi-FI', { hour: '2-digit', minute: '2-digit', }, )
#. placeholder {2}: endTime.toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit', })
#: src/routes/_app/visits/index.tsx
msgid "{0} at {1}-{2}"
msgstr "{0} a las {1}-{2}"

#. placeholder {0}: warrantyStats.expiringSoon
#: src/modules/maintenance/Summary.tsx
msgid "{0} expiring soon"
msgstr "{0} próximas a vencer"

#. placeholder {0}: taskAttachments.length
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "{0} photos"
msgstr "{0} fotos"

#. placeholder {0}: category.taskCount
#: src/modules/maintenance/Summary.tsx
msgid "{0} tasks"
msgstr "{0} tareas"

#. placeholder {0}: pkg.quantity
#. placeholder {1}: pkg.priceMonthly
#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "{0} x {1} €/mo ="
msgstr "{0} x {1} €/mes ="

#. placeholder {0}: hasDiscount ? effectivePrice : basePrice
#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "{0}€/mo"
msgstr "{0}€/mes"

#: src/modules/visit/FutureVisit.tsx
msgid "{attendeeCount} attendees"
msgstr "{attendeeCount} asistentes"

#: src/modules/home/components/MaintenanceCard.tsx
msgid "{completedCount}/{totalCount} done"
msgstr "{completedCount}/{totalCount} completadas"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "{dayName} {dateStr} at {startTimeStr} - {endTimeStr}"
msgstr "{dayName} {dateStr} a las {startTimeStr} - {endTimeStr}"

#: src/routes/_app/maintenance-log/index.tsx
msgid "{itemYear} maintenance activities"
msgstr "Actividades de mantenimiento de {itemYear}"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "{priceMonthly} €/mo"
msgstr "{priceMonthly} €/mes"

#: src/modules/visit/FutureVisit.tsx
msgid "{taskCount} tasks"
msgstr "{taskCount} tareas"

#: src/components/VisitListItem.tsx
msgid "{weekday} {day}. {month}, at {startTimeStr}-{endTimeStr}"
msgstr "{weekday} {day}. {month}, a las {startTimeStr}-{endTimeStr}"

#: src/modules/visit/FutureVisit.tsx
msgid "~{estimatedDuration} min"
msgstr "~{estimatedDuration} min"

#: src/components/profile/CustomerCard.tsx
#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
#: src/modules/subscription/components/PackageCard.tsx
msgid "€/mo"
msgstr "€/mes"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "1. Close your apartment's water shutoff valve"
msgstr "1. Cierre la válvula de corte de agua de su vivienda"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "12 tasks done, 36 remaining"
msgstr "12 tareas completadas, 36 pendientes"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "135,00 € / pcs"
msgstr "135,00 € / unidad"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "2. Call the emergency hotline at 020 7484 00"
msgstr "2. Llame a la línea de emergencias al 020 7484 00"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "24-hour service"
msgstr "Servicio 24 horas"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "24/7 service - including Christmas and Midsummer"
msgstr "Servicio 24/7 - incluyendo Navidad y festividades"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "3. Mention at the start of the call that you are a Markku.fi customer. Explain what happened and follow the instructions given to you."
msgstr "3. Mencione al inicio de la llamada que es cliente de Markku.fi. Explique lo que sucedió y siga las instrucciones que le den."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "4. File a claim with your insurance company"
msgstr "4. Presente una reclamación a su compañía de seguros"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "5. Add the damage report from Polygon to your Markku maintenance log."
msgstr "5. Añada el informe de daños de Polygon a su registro de mantenimiento de Markku."

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "7 days"
msgstr "7 días"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "A centralized place for all home information and images"
msgstr "Un lugar centralizado para toda la información e imágenes de su hogar"

#: src/modules/auth/WelcomeStep.tsx
msgid "A maintenance book that takes care of your home. Track maintenance needs, receive reminders and maintain your property's value."
msgstr "Un libro de mantenimiento que cuida de su hogar. Registre las necesidades de mantenimiento, reciba recordatorios y mantenga el valor de su propiedad."

#. placeholder {0}: task.estimatedDurationHours
#: src/modules/maintenance/YearCalendarCarousel/index.tsx
msgid "About {0} hours"
msgstr "Aproximadamente {0} horas"

#. placeholder {0}: task.estimatedDurationMinutes
#: src/routes/_app/maintenance-log/$id.tsx
msgid "About {0} minutes"
msgstr "Aproximadamente {0} minutos"

#: src/modules/auth/WelcomeStep.tsx
msgid "Accept terms of service"
msgstr "Aceptar términos de servicio"

#: src/modules/subscription/components/PackageCard.tsx
#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "Activate package"
msgstr "Activar paquete"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
#: src/modules/subscription/components/PackageCard.tsx
#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "Active"
msgstr "Activo"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
msgid "Active subscription"
msgstr "Suscripción activa"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Actual"
msgstr "Real"

#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Actual cost"
msgstr "Coste real"

#: src/modules/consumption/ConsumptionSummaryCards.tsx
#: src/modules/consumption/index.tsx
#: src/modules/costs/CostsPage/index.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Add"
msgstr "Añadir"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Add a detailed description of the task..."
msgstr "Añada una descripción detallada de la tarea..."

#: src/components/common/AttachmentField.tsx
msgid "Add attachment"
msgstr "Añadir adjunto"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Add cost"
msgstr "Añadir coste"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Add costs in the <0>Maintenance log</0>"
msgstr "Añada costes en el <0>Registro de mantenimiento</0>"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Add meter reading"
msgstr "Añadir lectura del contador"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Add more detailed description..."
msgstr "Añada una descripción más detallada..."

#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Add notes about the completed work..."
msgstr "Añada notas sobre el trabajo completado..."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Add notes about the task..."
msgstr "Añada notas sobre la tarea..."

#: src/components/profile/AddPropertyModal.tsx
#: src/components/profile/CustomerCard.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Add property"
msgstr "Añadir propiedad"

#: src/modules/maintenance/YearCalendarCarousel/TaskCard.tsx
msgid "Add task"
msgstr "Añadir tarea"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Add to calendar"
msgstr "Añadir al calendario"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Add your first property"
msgstr "Añada su primera propiedad"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Additional charges: mileage compensation €1.65/km (car/van), €2.40/km (truck), materials at Polygon list price -25% + material surcharge 12%, HVAC work and subcontracting +12%."
msgstr "Cargos adicionales: compensación por kilometraje 1,65€/km (coche/furgoneta), 2,40€/km (camión), materiales al precio de lista de Polygon -25% + recargo de material 12%, trabajos de climatización y subcontratación +12%."

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Additional info..."
msgstr "Información adicional..."

#: src/modules/visit/FutureVisit.tsx
msgid "Additional information"
msgstr "Información adicional"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Additional information (optional)"
msgstr "Información adicional (opcional)"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Additional work"
msgstr "Trabajo adicional"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Additional work will be added to your next monthly invoice automatically"
msgstr "El trabajo adicional se añadirá automáticamente a su próxima factura mensual"

#: src/modules/property/components/PropertyAddressCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Address"
msgstr "Dirección"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Address is required"
msgstr "La dirección es obligatoria"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "After"
msgstr "Después"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Alert!"
msgstr "¡Alerta!"

#: src/routes/_app/maintenance-log/index.tsx
msgid "All categories"
msgstr "Todas las categorías"

#: src/modules/home/components/EngagementCard.tsx
msgid "All maintenance supplies included in the price"
msgstr "Todos los materiales de mantenimiento incluidos en el precio"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "All OK"
msgstr "Todo bien"

#. placeholder {0}: allowedTypes.join(', ')
#: src/components/common/AttachmentField.tsx
msgid "Allowed types: {0}"
msgstr "Tipos permitidos: {0}"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Amount"
msgstr "Importe"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Amount due"
msgstr "Importe pendiente"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Annual calendar"
msgstr "Calendario anual"

#: src/components/profile/LanguageSettings.tsx
msgid "App language"
msgstr "Idioma de la aplicación"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Are you sure you want to delete this maintenance entry?"
msgstr "¿Está seguro de que desea eliminar esta entrada de mantenimiento?"

#. placeholder {0}: Number(consumption.meterReading).toFixed(1)
#. placeholder {1}: consumption.unit
#. placeholder {2}: formatDate(consumption.date)
#: src/modules/consumption/ConsumptionTable.tsx
msgid "Are you sure you want to delete this meter reading ({0} {1}, {2})?"
msgstr "¿Está seguro de que desea eliminar esta lectura del contador ({0} {1}, {2})?"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Are you sure you want to delete this task?"
msgstr "¿Está seguro de que desea eliminar esta tarea?"

#: src/routes/_app/profile.tsx
msgid "Are you sure you want to log out?"
msgstr "¿Está seguro de que desea cerrar sesión?"

#: src/routes/_app/messages/index.tsx
msgid "Ask questions, request help and track visits"
msgstr "Haga preguntas, solicite ayuda y realice seguimiento de las visitas"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "at"
msgstr "a las"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Attachments"
msgstr "Adjuntos"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Attachments are saved when the task is saved"
msgstr "Los adjuntos se guardan cuando se guarda la tarea"

#: src/modules/visit/FutureVisit.tsx
msgid "Attendees"
msgstr "Asistentes"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Autumn"
msgstr "Otoño"

#: src/modules/auth/EmailStep.tsx
#: src/modules/auth/OtpStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Back"
msgstr "Atrás"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Barcode"
msgstr "Código de barras"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "Before"
msgstr "Antes"

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Book a free survey visit"
msgstr "Reserve una visita de inspección gratuita"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Book visit"
msgstr "Reservar visita"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Booking successful!"
msgstr "¡Reserva exitosa!"

#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Budget variance"
msgstr "Variación del presupuesto"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Budgeted"
msgstr "Presupuestado"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Budgeted costs are calculated from task estimates"
msgstr "Los costes presupuestados se calculan a partir de las estimaciones de tareas"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Budgeting and household deduction"
msgstr "Presupuesto y deducción doméstica"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/visit/FeedbackModal.tsx
#: src/routes/_app/maintenance-log/$id.tsx
#: src/routes/_app/profile.tsx
msgid "Cancel"
msgstr "Cancelar"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Category"
msgstr "Categoría"

#: src/modules/visit/PastVisit/CertificatesCard.tsx
msgid "Certificate"
msgstr "Certificado"

#: src/modules/visit/PastVisit/CertificatesCard.tsx
msgid "Certificates"
msgstr "Certificados"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Certificates and user manuals"
msgstr "Certificados y manuales de usuario"

#: src/modules/maintenance/Summary.tsx
msgid "Certificates, manuals and receipts"
msgstr "Certificados, manuales y recibos"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Change package"
msgstr "Cambiar paquete"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Check"
msgstr "Verificar"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Check details"
msgstr "Verificar detalles"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Check form details"
msgstr "Verificar datos del formulario"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Check the form data"
msgstr "Verificar los datos del formulario"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Check your contact information"
msgstr "Verifique su información de contacto"

#. placeholder {0}: form.values.email
#: src/modules/auth/EmailStep.tsx
msgid "Check your email {0}"
msgstr "Revise su correo electrónico {0}"

#: src/modules/visit/PastVisit/CertificatesCard.tsx
msgid "Chimney sweep certificate"
msgstr "Certificado de deshollinador"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Choose a suitable time for the survey visit"
msgstr "Elija un horario adecuado para la visita de inspección"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "City"
msgstr "Ciudad"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Click the \"Add\" button on the card you want (electricity, water, or heating)"
msgstr "Haga clic en el botón \"Añadir\" en la tarjeta que desee (electricidad, agua o calefacción)"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
#: src/modules/subscription/components/ContractTermsModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Close"
msgstr "Cerrar"

#: src/modules/auth/OtpStep.tsx
msgid "Code must be 6 digits"
msgstr "El código debe tener 6 dígitos"

#: src/modules/auth/EmailStep.tsx
msgid "Code sent!"
msgstr "¡Código enviado!"

#: src/modules/consumption/ConsumptionChart.tsx
msgid "Comparison to previous year"
msgstr "Comparación con el año anterior"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Completed"
msgstr "Completado"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Completed maintenance task"
msgstr "Tarea de mantenimiento completada"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Completed maintenance tasks"
msgstr "Tareas de mantenimiento completadas"

#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Completed steps"
msgstr "Pasos completados"

#: src/modules/visit/PastVisit/CompletedTasksList.tsx
msgid "Completed tasks"
msgstr "Tareas completadas"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Completed tasks:"
msgstr "Tareas completadas:"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Completed work:"
msgstr "Trabajo completado:"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Completion date is required"
msgstr "La fecha de finalización es obligatoria"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Completion date is required when marking task as completed"
msgstr "La fecha de finalización es obligatoria al marcar la tarea como completada"

#: src/components/profile/AddPropertyModal.tsx
msgid "Construction year"
msgstr "Año de construcción"

#: src/modules/consumption/index.tsx
#: src/modules/consumption/index.tsx
#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Consumption tracking"
msgstr "Seguimiento de consumo"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Consumption type"
msgstr "Tipo de consumo"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Contact"
msgstr "Contacto"

#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "Contents:"
msgstr "Contenido:"

#: src/modules/auth/EmailStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Continue"
msgstr "Continuar"

#: src/modules/auth/GoogleButton.tsx
msgid "Continue with Google"
msgstr "Continuar con Google"

#: src/modules/subscription/components/ContractTermsModal.tsx
msgid "Contract terms – Markku.fi Home Services"
msgstr "Términos del contrato – Servicios del Hogar Markku.fi"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Copied"
msgstr "Copiado"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Copy"
msgstr "Copiar"

#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Cost"
msgstr "Coste"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Cost breakdown"
msgstr "Desglose de costes"

#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Cost information"
msgstr "Información de costes"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Cost management"
msgstr "Gestión de costes"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost name"
msgstr "Nombre del coste"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost name is required"
msgstr "El nombre del coste es obligatorio"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost saved"
msgstr "Coste guardado"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Cost tracking"
msgstr "Seguimiento de costes"

#: src/modules/costs/CostsPage/index.tsx
#: src/modules/costs/CostsPage/index.tsx
msgid "Costs"
msgstr "Costes"

#: src/modules/costs/CostsPage/CostsCategoryList.tsx
msgid "Costs by category"
msgstr "Costes por categoría"

#: src/modules/maintenance/components/FinancialQuickCard.tsx
msgid "Costs for {year}"
msgstr "Costes de {year}"

#. placeholder {0}: formatEuros(totalCost)
#: src/modules/maintenance/YearCalendarCarousel/SeasonHeader.tsx
msgid "Costs: {0}"
msgstr "Costes: {0}"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Create new task"
msgstr "Crear nueva tarea"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Current"
msgstr "Actual"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Customer comment:"
msgstr "Comentario del cliente:"

#: src/components/profile/CustomerCard.tsx
msgid "Customer name"
msgstr "Nombre del cliente"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Customer rating:"
msgstr "Valoración del cliente:"

#: src/routes/_app/messages/index.tsx
msgid "Customer service"
msgstr "Servicio al cliente"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Damage prevention (JVT)"
msgstr "Prevención de daños (JVT)"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Date"
msgstr "Fecha"

#: src/modules/visit/FutureVisit.tsx
msgid "Date and time"
msgstr "Fecha y hora"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Date is required"
msgstr "La fecha es obligatoria"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Deadline is required"
msgstr "La fecha límite es obligatoria"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Deadline:"
msgstr "Fecha límite:"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "December-February"
msgstr "Diciembre-Febrero"

#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/routes/_app/maintenance-log/$id.tsx
#: src/routes/_app/maintenance-log/$id.tsx
msgid "Delete"
msgstr "Eliminar"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Delete consumption"
msgstr "Eliminar consumo"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Delete entry"
msgstr "Eliminar entrada"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Delete task"
msgstr "Eliminar tarea"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Description"
msgstr "Descripción"

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
msgid "Details"
msgstr "Detalles"

#: src/routes/_app/profile.tsx
msgid "Developer settings"
msgstr "Configuración de desarrollador"

#: src/modules/home/components/EngagementCard.tsx
msgid "Did you know?"
msgstr "¿Sabía que?"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Digital maintenance book"
msgstr "Libro de mantenimiento digital"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Digital maintenance log"
msgstr "Registro de mantenimiento digital"

#: src/routes/_app/messages/index.tsx
msgid "Direct communication with maintenance staff"
msgstr "Comunicación directa con el personal de mantenimiento"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "discount"
msgstr "descuento"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Do you only see one package?"
msgstr "¿Solo ve un paquete?"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Documents"
msgstr "Documentos"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Documents and warranties"
msgstr "Documentos y garantías"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Doe"
msgstr "García"

#: src/modules/subscription/components/ContractTermsModal.tsx
msgid "Download contract terms (PDF)"
msgstr "Descargar términos del contrato (PDF)"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Download invoice (PDF)"
msgstr "Descargar factura (PDF)"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Due"
msgstr "Vence"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Due date"
msgstr "Fecha de vencimiento"

#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "During the visit, your property information was surveyed and updated."
msgstr "Durante la visita, la información de su propiedad fue inspeccionada y actualizada."

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 00100"
msgstr "ej. 28001"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 123 Main Street"
msgstr "ej. Calle Mayor 123"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 150"
msgstr "ej. 150"

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "E.g. 150"
msgstr "Ej. 150"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 2010"
msgstr "ej. 2010"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. Helsinki"
msgstr "ej. Madrid"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "E.g. Mannerheimintie 1"
msgstr "Ej. Calle Mayor 1"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "E.g. Pipe renovation, HVAC maintenance"
msgstr "Ej. Renovación de tuberías, mantenimiento de climatización"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "E.g. property age, condition, or other information that may help with the survey visit"
msgstr "Ej. antigüedad de la propiedad, estado, u otra información que pueda ayudar con la visita de inspección"

#: src/modules/maintenance/components/TaskDetails/index.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "E.g. Window cleaning"
msgstr "Ej. Limpieza de ventanas"

#: src/routes/_app/messages/index.tsx
msgid "Easily arrange visit times"
msgstr "Organice fácilmente los horarios de visita"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/routes/_app/maintenance-log/$id.tsx
msgid "Edit"
msgstr "Editar"

#: src/components/profile/CustomerCard.tsx
msgid "Edit customer"
msgstr "Editar cliente"

#: src/components/profile/PersonalInfoCard.tsx
msgid "Edit information"
msgstr "Editar información"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Edit meter reading"
msgstr "Editar lectura del contador"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Edit or delete costs by opening an individual maintenance entry"
msgstr "Edite o elimine costes abriendo una entrada de mantenimiento individual"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Edit task"
msgstr "Editar tarea"

#: src/modules/maintenance/Summary.tsx
msgid "Electrical systems"
msgstr "Sistemas eléctricos"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Electricity"
msgstr "Electricidad"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Electricity, water and heating"
msgstr "Electricidad, agua y calefacción"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/auth/EmailStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Email"
msgstr "Correo electrónico"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Email address cannot be changed"
msgstr "La dirección de correo electrónico no se puede cambiar"

#. placeholder {0}: INVOICE_FEES.EMAIL
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Email invoice will be sent automatically (includes {0}€ invoicing fee). Payment period is 14 days from invoice date."
msgstr "La factura por correo electrónico se enviará automáticamente (incluye {0}€ de cargo por facturación). El período de pago es de 14 días desde la fecha de la factura."

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Email invoice will be sent automatically. Payment period is 14 days from invoice date."
msgstr "La factura por correo electrónico se enviará automáticamente. El período de pago es de 14 días desde la fecha de la factura."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Emergency call fee"
msgstr "Cargo por llamada de emergencia"

#: src/modules/home/components/EngagementCard.tsx
msgid "Emergency repairs 24/7"
msgstr "Reparaciones de emergencia 24/7"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Enter the current meter reading. Consumption is calculated automatically from the previous reading."
msgstr "Introduzca la lectura actual del contador. El consumo se calcula automáticamente a partir de la lectura anterior."

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Enter the current meter reading. This will serve as the starting point for consumption calculation."
msgstr "Introduzca la lectura actual del contador. Esto servirá como punto de partida para el cálculo del consumo."

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "Enter the total floor area to see all suitable packages"
msgstr "Introduzca la superficie total para ver todos los paquetes adecuados"

#: src/modules/auth/OtpStep.tsx
msgid "Enter verification code"
msgstr "Introduzca el código de verificación"

#: src/modules/auth/EmailStep.tsx
msgid "Enter your email address"
msgstr "Introduzca su dirección de correo electrónico"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Enter your property's total floor area in the card above, and we'll show you all suitable Markku packages."
msgstr "Introduzca la superficie total de su propiedad en la tarjeta de arriba y le mostraremos todos los paquetes Markku adecuados."

#: src/components/ErrorAlert.tsx
#: src/components/profile/AddPropertyModal.tsx
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/invoice.ts
#: src/lib/trpcHooks/user.ts
#: src/lib/trpcHooks/user.ts
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/visit/FeedbackModal.tsx
#: src/routes/impersonate.tsx
msgid "Error"
msgstr "Error"

#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Estimate"
msgstr "Estimación"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Estimated cost (optional)"
msgstr "Coste estimado (opcional)"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "Estimated end time at"
msgstr "Hora estimada de finalización a las"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Estimated end time at {formattedEndTime}"
msgstr "Hora estimada de finalización a las {formattedEndTime}"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Example Street 1"
msgstr "Calle Ejemplo 1"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Explore Markku packages"
msgstr "Explorar paquetes Markku"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "Explore packages"
msgstr "Explorar paquetes"

#: src/modules/maintenance/Summary.tsx
msgid "Facade"
msgstr "Fachada"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to accept offer"
msgstr "Error al aceptar la oferta"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to create payment"
msgstr "Error al crear el pago"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to create payment session"
msgstr "Error al crear la sesión de pago"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Failed to delete task"
msgstr "Error al eliminar la tarea"

#: src/components/ErrorAlert.tsx
msgid "Failed to load data. Please try again."
msgstr "Error al cargar los datos. Por favor, inténtelo de nuevo."

#: src/lib/trpcHooks/billing.ts
msgid "Failed to open billing portal"
msgstr "Error al abrir el portal de facturación"

#: src/lib/trpcHooks/invoice.ts
msgid "Failed to open payment page"
msgstr "Error al abrir la página de pago"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Failed to save cost"
msgstr "Error al guardar el coste"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Failed to save task"
msgstr "Error al guardar la tarea"

#: src/lib/trpcHooks/user.ts
msgid "Failed to update information"
msgstr "Error al actualizar la información"

#: src/lib/trpcHooks/user.ts
msgid "Failed to update settings"
msgstr "Error al actualizar la configuración"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Fall tasks"
msgstr "Tareas de otoño"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "fall's"
msgstr "de otoño"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "First meter reading"
msgstr "Primera lectura del contador"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "First name"
msgstr "Nombre"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "First name is required"
msgstr "El nombre es obligatorio"

#: src/components/profile/AddPropertyModal.tsx
msgid "Floor area in square meters (m²)"
msgstr "Superficie en metros cuadrados (m²)"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Follow seasonal maintenance tasks and keep your home in shape all year round"
msgstr "Siga las tareas de mantenimiento estacional y mantenga su hogar en forma durante todo el año"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "FREE"
msgstr "GRATIS"

#: src/modules/visit/FeedbackModal.tsx
msgid "Free feedback (optional)"
msgstr "Comentarios libres (opcional)"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Free maintenance program for your property"
msgstr "Programa de mantenimiento gratuito para su propiedad"

#: src/components/profile/AddPropertyModal.tsx
msgid "Free-form notes about the property"
msgstr "Notas libres sobre la propiedad"

#: src/modules/maintenance/Summary.tsx
msgid "Full maintenance history"
msgstr "Historial completo de mantenimiento"

#: src/modules/home/components/EngagementCard.tsx
msgid "Get a free month when your friend joins"
msgstr "Obtenga un mes gratis cuando su amigo se una"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Get additional help at home"
msgstr "Obtenga ayuda adicional en casa"

#: src/modules/auth/WelcomeStep.tsx
msgid "Get started"
msgstr "Comenzar"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgctxt "subscription"
msgid "Get started"
msgstr "Comenzar"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Get tips for home maintenance and special offers from our partners"
msgstr "Reciba consejos de mantenimiento del hogar y ofertas especiales de nuestros socios"

#: src/components/VisitListItem.tsx
#: src/modules/home/components/EngagementCard.tsx
#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Give feedback"
msgstr "Dar opinión"

#: src/modules/visit/FeedbackModal.tsx
msgid "Great that the visit went well!"
msgstr "¡Qué bien que la visita haya ido bien!"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Gutter cleaning"
msgstr "Limpieza de canalones"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Heating"
msgstr "Calefacción"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Heating summer setting"
msgstr "Configuración de verano de la calefacción"

#: src/modules/maintenance/Summary.tsx
msgid "Heating systems"
msgstr "Sistemas de calefacción"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Helps with budgeting and annual planning"
msgstr "Ayuda con el presupuesto y la planificación anual"

#: src/config/navigation.tsx
msgid "Home"
msgstr "Inicio"

#: src/modules/home/components/EngagementCard.tsx
#: src/modules/visit/FeedbackModal.tsx
msgid "How did the visit go?"
msgstr "¿Cómo fue la visita?"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "How did the visit go? Your feedback helps us improve our service."
msgstr "¿Cómo fue la visita? Sus comentarios nos ayudan a mejorar nuestro servicio."

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "How to get started:"
msgstr "Cómo empezar:"

#: src/modules/visit/FeedbackModal.tsx
msgid "How would you rate Markku's visit?"
msgstr "¿Cómo calificaría la visita de Markku?"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Humidity"
msgstr "Humedad"

#: src/modules/maintenance/Summary.tsx
msgid "HVAC systems"
msgstr "Sistemas de climatización"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "I accept the"
msgstr "Acepto los"

#: src/modules/subscription/components/PackageCard.tsx
msgid "I accept the <0>contract terms</0>"
msgstr "Acepto los <0>términos del contrato</0>"

#: src/modules/auth/WelcomeStep.tsx
msgid "I accept the <0>terms of service</0> and <1>privacy policy</1>"
msgstr "Acepto los <0>términos de servicio</0> y la <1>política de privacidad</1>"

#: src/components/property/WelcomePropertyModal.tsx
msgid "I want to receive Markku maintenance offers and benefits"
msgstr "Quiero recibir ofertas y beneficios de mantenimiento de Markku"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "IBAN"
msgstr "IBAN"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "If you are interested in our services, contact us:"
msgstr "Si está interesado en nuestros servicios, contáctenos:"

#. placeholder {0}: INVOICE_FEES.EMAIL
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "If you don't pay in app by the deadline, we will send an email invoice (includes {0}€ invoicing fee). Invoice payment period is 14 days."
msgstr "Si no paga en la aplicación antes de la fecha límite, le enviaremos una factura por correo electrónico (incluye {0}€ de cargo por facturación). El período de pago de la factura es de 14 días."

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "If you don't pay in app by the deadline, we will send an email invoice. Invoice payment period is 14 days."
msgstr "Si no paga en la aplicación antes de la fecha límite, le enviaremos una factura por correo electrónico. El período de pago de la factura es de 14 días."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "If you have questions about this task or notice a problem, contact our customer service."
msgstr "Si tiene preguntas sobre esta tarea o detecta un problema, contacte con nuestro servicio de atención al cliente."

#: src/routes/impersonate.tsx
msgid "Impersonation failed"
msgstr "Error de suplantación"

#: src/routes/impersonate.tsx
msgid "Impersonation successful"
msgstr "Suplantación exitosa"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "In many cases, the insurance company will reimburse the costs of damage prevention, but each case is handled individually."
msgstr "En muchos casos, la compañía de seguros reembolsará los costes de prevención de daños, pero cada caso se gestiona individualmente."

#: src/modules/subscription/components/PackageCard.tsx
msgid "Includes:"
msgstr "Incluye:"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Indoor air specialist"
msgstr "Especialista en calidad del aire interior"

#: src/lib/trpcHooks/user.ts
#: src/lib/trpcHooks/user.ts
msgid "Information updated"
msgstr "Información actualizada"

#: src/modules/auth/EmailStep.tsx
msgid "Invalid email address"
msgstr "Dirección de correo electrónico no válida"

#: src/components/common/AttachmentField.tsx
msgid "Invalid file type"
msgstr "Tipo de archivo no válido"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Invalid phone number"
msgstr "Número de teléfono no válido"

#: src/modules/home/components/EngagementCard.tsx
msgid "Invite a friend"
msgstr "Invitar a un amigo"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoice"
msgstr "Factura"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoiced work:"
msgstr "Trabajo facturado:"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoices"
msgstr "Facturas"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "John"
msgstr "Juan"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "June-August"
msgstr "Junio-Agosto"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Last name"
msgstr "Apellido"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Last name is required"
msgstr "El apellido es obligatorio"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Lawn spring maintenance"
msgstr "Mantenimiento de primavera del césped"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "LEAK!"
msgstr "¡FUGA!"

#: src/modules/home/components/EngagementCard.tsx
msgid "Learn about Markku service"
msgstr "Conozca el servicio Markku"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Leave empty if no costs incurred"
msgstr "Deje vacío si no hay costes incurridos"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "Less worry, more time"
msgstr "Menos preocupaciones, más tiempo"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgid "Let Markku take care of it!"
msgstr "¡Deje que Markku se encargue!"

#: src/modules/maintenance/Summary.tsx
msgid "List of all maintenance records"
msgstr "Lista de todos los registros de mantenimiento"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Live"
msgstr "En vivo"

#: src/components/profile/AddPropertyModal.tsx
msgid "Living area"
msgstr "Superficie habitable"

#: src/modules/maintenance/YearCalendarCarousel/index.tsx
msgid "Loading maintenance tasks..."
msgstr "Cargando tareas de mantenimiento..."

#: src/modules/maintenance/Summary.tsx
msgid "Loading summary..."
msgstr "Cargando resumen..."

#: src/routes/_app/messages/$id.tsx
msgid "Loading..."
msgstr "Cargando..."

#: src/modules/visit/FutureVisit.tsx
msgid "Location"
msgstr "Ubicación"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Locking"
msgstr "Cerradura"

#: src/modules/auth/OtpStep.tsx
msgid "Log in"
msgstr "Iniciar sesión"

#: src/routes/_app/profile.tsx
#: src/routes/_app/profile.tsx
#: src/routes/_app/profile.tsx
msgid "Log out"
msgstr "Cerrar sesión"

#: src/modules/auth/OtpStep.tsx
msgid "Login code"
msgstr "Código de inicio de sesión"

#: src/modules/auth/WelcomeLogin.tsx
msgid "Login required"
msgstr "Inicio de sesión requerido"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Maintain property information"
msgstr "Mantener información de la propiedad"

#: src/config/navigation.tsx
msgid "Maintenance"
msgstr "Mantenimiento"

#: src/modules/maintenance/Summary.tsx
msgid "Maintenance categories"
msgstr "Categorías de mantenimiento"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Maintenance history"
msgstr "Historial de mantenimiento"

#: src/routes/_app/visits/index.tsx
msgid "Maintenance history and visit records"
msgstr "Historial de mantenimiento y registros de visitas"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Maintenance log"
msgstr "Registro de mantenimiento"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Maintenance task"
msgstr "Tarea de mantenimiento"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Maintenance task not found"
msgstr "Tarea de mantenimiento no encontrada"

#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "Manage"
msgstr "Gestionar"

#: src/components/profile/CustomerCard.tsx
msgid "Manage payment method and invoices"
msgstr "Gestionar método de pago y facturas"

#: src/modules/maintenance/Summary.tsx
msgid "Manage property information"
msgstr "Gestionar información de la propiedad"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Manage your subscription"
msgstr "Gestionar su suscripción"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "March-May"
msgstr "Marzo-Mayo"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Mark as completed"
msgstr "Marcar como completada"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Markku currently serves the Helsinki metropolitan area and its surroundings."
msgstr "Markku actualmente ofrece servicio en el área metropolitana de Helsinki y alrededores."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Markku customer prices (incl. VAT 25.5%):"
msgstr "Precios para clientes Markku (IVA 25,5% incluido):"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "Markku handles"
msgstr "Markku se encarga"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Markku handles this task"
msgstr "Markku se encarga de esta tarea"

#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Markku package"
msgstr "Paquete Markku"

#: src/routes/_app/maintenance-services.tsx
msgid "Markku packages"
msgstr "Paquetes Markku"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "Markku recommends for you"
msgstr "Markku le recomienda"

#: src/modules/home/components/EngagementCard.tsx
msgid "Markku service includes:"
msgstr "El servicio Markku incluye:"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Markku service technician"
msgstr "Técnico de servicio Markku"

#: src/routes/_app/visits/index.tsx
msgid "Markku takes care of your home maintenance"
msgstr "Markku se encarga del mantenimiento de su hogar"

#: src/routes/_app/visits/index.tsx
msgid "Markku.fi is a home maintenance service in the Helsinki metropolitan area. After activating your subscription, Markku will regularly visit your home to handle the maintenance tasks included in the contract and, if needed, small repairs and installations."
msgstr "Markku.fi es un servicio de mantenimiento del hogar en el área metropolitana de Helsinki. Después de activar su suscripción, Markku visitará regularmente su hogar para encargarse de las tareas de mantenimiento incluidas en el contrato y, si es necesario, pequeñas reparaciones e instalaciones."

#: src/routes/_app/messages/index.tsx
msgid "Markku.fi subscribers can message directly with maintenance staff to arrange visit times, ask questions and request help with small repairs or installations."
msgstr "Los suscriptores de Markku.fi pueden comunicarse directamente con el personal de mantenimiento para organizar horarios de visita, hacer preguntas y solicitar ayuda con pequeñas reparaciones o instalaciones."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Markku.fi survey visit"
msgstr "Visita de inspección Markku.fi"

#: src/modules/home/components/UpcomingVisitCard.tsx
#: src/routes/_app/visits/index.tsx
msgid "Markku's next visit"
msgstr "Próxima visita de Markku"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/VisitNotesCard.tsx
msgid "Markku's notes"
msgstr "Notas de Markku"

#: src/routes/_app/visits/index.tsx
msgid "Markku's visits"
msgstr "Visitas de Markku"

#: src/components/profile/CustomerCard.tsx
#: src/components/profile/CustomerCard.tsx
msgid "Member"
msgstr "Miembro"

#: src/components/profile/CustomerCard.tsx
msgid "Members"
msgstr "Miembros"

#: src/config/navigation.tsx
#: src/routes/_app/messages/index.tsx
#: src/routes/_app/messages/index.tsx
#: src/routes/_app/messages/index.tsx
msgid "Messages"
msgstr "Mensajes"

#: src/routes/_app/messages/index.tsx
msgid "Messages with Markku"
msgstr "Mensajes con Markku"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
msgid "Meter reading"
msgstr "Lectura del contador"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Meter reading must be positive"
msgstr "La lectura del contador debe ser positiva"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Meter readings"
msgstr "Lecturas del contador"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Moisture/fire damage assessment"
msgstr "Evaluación de daños por humedad/fuego"

#: src/modules/consumption/ConsumptionChart.tsx
msgid "Monthly consumption"
msgstr "Consumo mensual"

#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
msgid "Monthly costs"
msgstr "Costes mensuales"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "My tasks"
msgstr "Mis tareas"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Name"
msgstr "Nombre"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "New"
msgstr "Nuevo"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "New additional work will be added automatically to your next monthly invoice. You don't need to do anything."
msgstr "El nuevo trabajo adicional se añadirá automáticamente a su próxima factura mensual. No necesita hacer nada."

#: src/modules/home/components/ActivityFeed.tsx
msgid "News"
msgstr "Noticias"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Next time, consumption is calculated automatically: new reading - previous reading"
msgstr "La próxima vez, el consumo se calculará automáticamente: nueva lectura - lectura anterior"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Next visit"
msgstr "Próxima visita"

#: src/routes/_app/visits/index.tsx
msgid "Next visit will be arranged separately"
msgstr "La próxima visita se organizará por separado"

#: src/components/profile/CustomerCard.tsx
msgid "No active subscription"
msgstr "Sin suscripción activa"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "No available times for the selected day, check the next day."
msgstr "No hay horarios disponibles para el día seleccionado, consulte el siguiente día."

#: src/routes/_app/maintenance-log/index.tsx
msgid "No completed maintenance tasks with selected filters"
msgstr "No hay tareas de mantenimiento completadas con los filtros seleccionados"

#: src/routes/_app/messages/index.tsx
msgid "No conversations yet"
msgstr "Sin conversaciones todavía"

#: src/routes/_app/maintenance.tsx
msgid "No customer"
msgstr "Sin cliente"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No Markku tasks for this season"
msgstr "No hay tareas de Markku para esta temporada"

#: src/routes/_app/messages/index.tsx
msgid "No messages yet - start a conversation"
msgstr "Sin mensajes todavía - inicie una conversación"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No personal tasks for this season"
msgstr "No hay tareas personales para esta temporada"

#: src/components/profile/CustomerCard.tsx
msgid "No properties"
msgstr "Sin propiedades"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No recommended tasks for this season"
msgstr "No hay tareas recomendadas para esta temporada"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgid "No stress, no hard work - just a well-maintained home"
msgstr "Sin estrés, sin trabajo duro - solo un hogar bien mantenido"

#: src/components/VisitListItem.tsx
msgid "No tasks"
msgstr "Sin tareas"

#: src/routes/_app/visits/index.tsx
msgid "No upcoming visits"
msgstr "Sin visitas programadas"

#. placeholder {0}: step.notes
#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Note: {0}"
msgstr "Nota: {0}"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Note: If the work is covered by an insurance company, the prices agreed between Polygon and the insurance company apply."
msgstr "Nota: Si el trabajo está cubierto por una compañía de seguros, se aplican los precios acordados entre Polygon y la compañía de seguros."

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Notes"
msgstr "Notas"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Notes (optional)"
msgstr "Notas (opcional)"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Notes about the task (optional)"
msgstr "Notas sobre la tarea (opcional)"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Notes saved"
msgstr "Notas guardadas"

#: src/modules/home/components/Header.tsx
msgid "Notifications"
msgstr "Notificaciones"

#: src/modules/maintenance/components/YearSummaryCard.tsx
msgid "Of the year's <0>{totalTasks}</0> tasks, <1>Markku handles {markkuTasks}</1>, saving you approximately <2>{savedHours} hours</2>."
msgstr "De las <0>{totalTasks}</0> tareas del año, <1>Markku se encarga de {markkuTasks}</1>, ahorrándole aproximadamente <2>{savedHours} horas</2>."

#: src/modules/subscription/components/PackageCard.tsx
msgid "Only the owner can subscribe to packages"
msgstr "Solo el propietario puede suscribirse a paquetes"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Open"
msgstr "Pendiente"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
msgid "Open history"
msgstr "Abrir historial"

#: src/modules/home/components/MaintenanceCard.tsx
msgid "Open maintenance book"
msgstr "Abrir libro de mantenimiento"

#: src/modules/auth/WelcomeStep.tsx
msgid "or"
msgstr "o"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Order additional services"
msgstr "Solicitar servicios adicionales"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Other"
msgstr "Otro"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Other address"
msgstr "Otra dirección"

#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Our customer service is open on weekdays 8-16"
msgstr "Nuestro servicio de atención al cliente está abierto de lunes a viernes de 8 a 16"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Outside service area"
msgstr "Fuera del área de servicio"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Overdue"
msgstr "Vencida"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Overtime and additional fees: Overtime is charged according to actual hours with percentage increases per the Technology Industry Workers' Collective Agreement. Holiday eve +100% (previous weekday 18:00 – next day 06:00), Public holiday +100% (previous weekday/Saturday 18:00 – next weekday 06:00)."
msgstr "Horas extras y cargos adicionales: Las horas extras se cobran según las horas reales con aumentos porcentuales según el Convenio Colectivo de Trabajadores de la Industria Tecnológica. Víspera de festivo +100% (día laborable anterior 18:00 - día siguiente 06:00), Festivo +100% (día laborable/sábado anterior 18:00 - siguiente día laborable 06:00)."

#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Overview"
msgstr "Resumen"

#: src/components/profile/CustomerCard.tsx
#: src/components/profile/CustomerCard.tsx
msgid "Owner"
msgstr "Propietario"

#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "Package"
msgstr "Paquete"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Paid"
msgstr "Pagada"

#. placeholder {0}: formatDate(paidDate)
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Paid {0}"
msgstr "Pagado {0}"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Paid work:"
msgstr "Trabajo pagado:"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Part of the Markku package"
msgstr "Parte del paquete Markku"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Partially paid"
msgstr "Parcialmente pagado"

#: src/routes/_app/visits/$id.tsx
msgid "Past visit"
msgstr "Visita pasada"

#. placeholder {0}: formatDateTime(deadline.toISOString())
#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Pay in app before {0}"
msgstr "Pague en la aplicación antes del {0}"

#. placeholder {0}: formatDateTime(deadline.toISOString())
#. placeholder {1}: INVOICE_FEES.EMAIL
#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Pay in app before {0} and save {1}€ invoicing fee"
msgstr "Pague en la aplicación antes del {0} y ahorre {1}€ de cargo por facturación"

#. placeholder {0}: INVOICE_FEES.EMAIL
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Pay in app before deadline and save {0}€"
msgstr "Pague en la aplicación antes de la fecha límite y ahorre {0}€"

#: src/modules/home/components/VisitPaymentBanner.tsx
#: src/modules/visit/PastVisit/InvoiceItem.tsx
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Pay now"
msgstr "Pagar ahora"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Payment"
msgstr "Pago"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Payment deadline"
msgstr "Fecha límite de pago"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Payment deadline in app has expired"
msgstr "La fecha límite de pago en la aplicación ha expirado"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "PDF invoice download failed. Please try again later."
msgstr "Error al descargar la factura PDF. Por favor, inténtelo de nuevo más tarde."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Peace of mind and time savings"
msgstr "Tranquilidad y ahorro de tiempo"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Peace of mind around the clock"
msgstr "Tranquilidad las 24 horas"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Performed by"
msgstr "Realizado por"

#: src/components/profile/NotificationSettings.tsx
msgid "Permission denied in browser"
msgstr "Permiso denegado en el navegador"

#: src/components/profile/PersonalInfoCard.tsx
msgid "Personal information"
msgstr "Información personal"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Phone number"
msgstr "Número de teléfono"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Phone number is required"
msgstr "El número de teléfono es obligatorio"

#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Photos"
msgstr "Fotos"

#: src/modules/visit/FutureVisit.tsx
msgid "Planned tasks"
msgstr "Tareas planificadas"

#: src/components/profile/AddPropertyModal.tsx
msgid "Please fill in all required fields"
msgstr "Por favor, complete todos los campos obligatorios"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Pool"
msgstr "Piscina"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Postal code"
msgstr "Código postal"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Postal code is required"
msgstr "El código postal es obligatorio"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Postal code must be 5 digits"
msgstr "El código postal debe tener 5 dígitos"

#. placeholder {0}: calculation.previousReading.toFixed(1)
#. placeholder {1}: form.values.unit
#. placeholder {2}: formatDate(calculation.previousDate!)
#: src/modules/consumption/ConsumptionModal.tsx
msgid "Previous reading: {0} {1} ({2})"
msgstr "Lectura anterior: {0} {1} ({2})"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Price"
msgstr "Precio"

#: src/routes/_app/visits/index.tsx
msgid "Professional maintenance staff handles the tasks"
msgstr "Personal de mantenimiento profesional se encarga de las tareas"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Professionals handle the tasks"
msgstr "Profesionales se encargan de las tareas"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Professionals on site quickly"
msgstr "Profesionales en el lugar rápidamente"

#: src/config/navigation.tsx
#: src/routes/_app/profile.tsx
msgid "Profile"
msgstr "Perfil"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Project management"
msgstr "Gestión de proyectos"

#: src/components/profile/CustomerCard.tsx
msgid "Properties"
msgstr "Propiedades"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Property"
msgstr "Propiedad"

#. placeholder {0}: p.id
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Property {0}"
msgstr "Propiedad {0}"

#: src/components/property/WelcomePropertyModal.tsx
#: src/components/property/WelcomePropertyModal.tsx
#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Property details"
msgstr "Detalles de la propiedad"

#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "Property information updated"
msgstr "Información de la propiedad actualizada"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Property type"
msgstr "Tipo de propiedad"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Property type is required"
msgstr "El tipo de propiedad es obligatorio"

#: src/components/profile/NotificationSettings.tsx
msgid "Push notifications"
msgstr "Notificaciones push"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "QR code"
msgstr "Código QR"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Quick actions"
msgstr "Acciones rápidas"

#: src/components/profile/NotificationSettings.tsx
msgid "Receive notifications"
msgstr "Recibir notificaciones"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Recipient"
msgstr "Beneficiario"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Recommended for you"
msgstr "Recomendado para usted"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "Recommended tasks"
msgstr "Tareas recomendadas"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Reference"
msgstr "Referencia"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Regular maintenance - no surprises"
msgstr "Mantenimiento regular - sin sorpresas"

#: src/modules/home/components/EngagementCard.tsx
msgid "Regular maintenance visits from professionals"
msgstr "Visitas de mantenimiento regulares de profesionales"

#: src/routes/_app/visits/index.tsx
msgid "Regular maintenance visits year-round"
msgstr "Visitas de mantenimiento regulares durante todo el año"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "remaining"
msgstr "restante"

#. placeholder {0}: invoice.voidedInvoice.invoiceNumber
#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Replaces invoice {0}"
msgstr "Sustituye la factura {0}"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Reschedule visit"
msgstr "Reprogramar visita"

#: src/modules/auth/OtpStep.tsx
msgid "Resend code"
msgstr "Reenviar código"

#: src/modules/maintenance/Summary.tsx
msgid "Roof and attic"
msgstr "Tejado y ático"

#: src/components/profile/AddPropertyModal.tsx
#: src/components/profile/CustomerCard.tsx
#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Save"
msgstr "Guardar"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Save failed"
msgstr "Error al guardar"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Save home details, photos and technical system documentation"
msgstr "Guarde detalles del hogar, fotos y documentación de sistemas técnicos"

#: src/modules/visit/FeedbackModal.tsx
msgid "Saving feedback failed. Please try again."
msgstr "Error al guardar los comentarios. Por favor, inténtelo de nuevo."

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Scan with your banking app"
msgstr "Escanea con tu app bancaria"

#: src/modules/visit/FutureVisit.tsx
msgid "Scheduled"
msgstr "Programada"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Select a suitable Markku package for your property. We handle all necessary maintenance and keep your property in good condition."
msgstr "Seleccione un paquete Markku adecuado para su propiedad. Nos encargamos de todo el mantenimiento necesario y mantenemos su propiedad en buenas condiciones."

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Select category"
msgstr "Seleccionar categoría"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Select city"
msgstr "Seleccionar ciudad"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Select date"
msgstr "Seleccionar fecha"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Select date and time"
msgstr "Seleccionar fecha y hora"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Select day"
msgstr "Seleccionar día"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Select package"
msgstr "Seleccionar paquete"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Select property"
msgstr "Seleccionar propiedad"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Select target"
msgstr "Seleccionar destino"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Select type"
msgstr "Seleccionar tipo"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Select year"
msgstr "Seleccionar año"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "September-November"
msgstr "Septiembre-Noviembre"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Service"
msgstr "Servicio"

#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Service available in the Helsinki metropolitan area and nearby regions"
msgstr "Servicio disponible en el área metropolitana de Helsinki y regiones cercanas"

#: src/modules/home/components/EngagementCard.tsx
msgid "Share your invite link"
msgstr "Comparta su enlace de invitación"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Show all"
msgstr "Mostrar todo"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
msgid "Show contract terms"
msgstr "Mostrar términos del contrato"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Show details"
msgstr "Mostrar detalles"

#: src/routes/_app/profile.tsx
msgid "Show placeholder content"
msgstr "Mostrar contenido de marcador de posición"

#. placeholder {0}: userData.firstName
#. placeholder {1}: userData.lastName
#: src/routes/impersonate.tsx
msgid "Signed in as {0} {1}"
msgstr "Sesión iniciada como {0} {1}"

#: src/modules/auth/GoogleButton.tsx
#: src/modules/auth/GoogleCallback.tsx
#: src/routes/impersonate.tsx
msgid "Signing in..."
msgstr "Iniciando sesión..."

#: src/modules/visit/FeedbackModal.tsx
msgid "Sorry that the visit didn't meet your expectations"
msgstr "Lamentamos que la visita no cumpliera sus expectativas"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Special cleaning"
msgstr "Limpieza especial"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Spring"
msgstr "Primavera"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Spring tasks"
msgstr "Tareas de primavera"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "spring's"
msgstr "de primavera"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Start by adding a property"
msgstr "Comience añadiendo una propiedad"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Start by adding a property for the maintenance log"
msgstr "Comience añadiendo una propiedad para el registro de mantenimiento"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Start consumption tracking"
msgstr "Iniciar seguimiento de consumo"

#. placeholder {0}: index + 1
#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Step {0}"
msgstr "Paso {0}"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Store documents"
msgstr "Almacenar documentos"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Store warranties, receipts and important documents safely in one place"
msgstr "Almacene garantías, recibos y documentos importantes de forma segura en un solo lugar"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Street address"
msgstr "Dirección"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Street address is required"
msgstr "La dirección es obligatoria"

#: src/modules/visit/FeedbackModal.tsx
msgid "Submit feedback"
msgstr "Enviar comentarios"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Subscribe to package"
msgstr "Suscribirse al paquete"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Success"
msgstr "Éxito"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Summer"
msgstr "Verano"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Summer tasks"
msgstr "Tareas de verano"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "summer's"
msgstr "de verano"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Survey visit - Markku.fi"
msgstr "Visita de inspección - Markku.fi"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Take care of your home easily. Markku helps you track your property's maintenance work, store important documents and maintain your home's value."
msgstr "Cuide de su hogar fácilmente. Markku le ayuda a realizar un seguimiento del mantenimiento de su propiedad, almacenar documentos importantes y mantener el valor de su hogar."

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Target"
msgstr "Destino"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Task"
msgstr "Tarea"

#. placeholder {0}: index + 1
#: src/modules/visit/FutureVisit.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "Task {0}"
msgstr "Tarea {0}"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task deadline"
msgstr "Fecha límite de la tarea"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task deleted"
msgstr "Tarea eliminada"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Task details"
msgstr "Detalles de la tarea"

#: src/modules/maintenance/components/TaskDetails/index.tsx
msgid "Task is already completed"
msgstr "La tarea ya está completada"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Task marked as completed"
msgstr "Tarea marcada como completada"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Task not found"
msgstr "Tarea no encontrada"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task saved"
msgstr "Tarea guardada"

#: src/modules/maintenance/components/TaskDetails/index.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task title"
msgstr "Título de la tarea"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task title is required"
msgstr "El título de la tarea es obligatorio"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Task to be handled"
msgstr "Tarea a realizar"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Task type"
msgstr "Tipo de tarea"

#. placeholder {0}: getSeasonName(deadlineSeason)
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task will be added to the {0} list based on the deadline"
msgstr "La tarea se añadirá a la lista de {0} según la fecha límite"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "tasks"
msgstr "tareas"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "tasks paid"
msgstr "tareas pagadas"

#: src/modules/visit/FeedbackModal.tsx
msgid "Tell us how we could serve you better..."
msgstr "Cuéntenos cómo podemos servirle mejor..."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Tell us the property location and type"
msgstr "Indíquenos la ubicación y tipo de propiedad"

#: src/modules/visit/FeedbackModal.tsx
msgid "Tell us what you especially appreciated about the visit..."
msgstr "Cuéntenos qué apreció especialmente de la visita..."

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Temperature"
msgstr "Temperatura"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "terms and conditions"
msgstr "términos y condiciones"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Terrace maintenance"
msgstr "Mantenimiento de terraza"

#. placeholder {0}: user.firstName
#. placeholder {1}: user.lastName
#: src/components/ImpersonationBanner.tsx
msgid "Test mode: Logged in as {0} {1}"
msgstr "Modo de prueba: Sesión iniciada como {0} {1}"

#: src/modules/visit/FeedbackModal.tsx
msgid "Thank you for your feedback"
msgstr "Gracias por sus comentarios"

#: src/modules/visit/FeedbackModal.tsx
msgid "Thank you for your feedback!"
msgstr "¡Gracias por sus comentarios!"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "The additional work listed below will be added automatically to your next monthly invoice. You don't need to do anything."
msgstr "El trabajo adicional que se indica a continuación se añadirá automáticamente a su próxima factura mensual. No necesita hacer nada."

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "The annual calendar reminds you of seasonal maintenance tasks"
msgstr "El calendario anual le recuerda las tareas de mantenimiento estacional"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The apartment's water shutoff valve is usually found in your apartment's utility room near the main water meter."
msgstr "La válvula de corte de agua del apartamento suele encontrarse en el cuarto de instalaciones de su apartamento, cerca del contador principal de agua."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The call is directed to our partner Polygon's emergency service, which is available 24/7. In addition to water damage, you can report minor fire damage, such as when smoke has entered the apartment."
msgstr "La llamada se dirige al servicio de emergencias de nuestro socio Polygon, que está disponible 24/7. Además de daños por agua, puede reportar daños menores por fuego, como cuando el humo ha entrado en el apartamento."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The customer relationship is established between you and Polygon during the call. They will bill you directly for the emergency visit and damage prevention. We have negotiated the discounted prices shown below for Markku customers."
msgstr "La relación con el cliente se establece entre usted y Polygon durante la llamada. Le facturarán directamente por la visita de emergencia y la prevención de daños. Hemos negociado los precios con descuento que se muestran a continuación para los clientes de Markku."

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "The maintenance book helps you:"
msgstr "El libro de mantenimiento le ayuda a:"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "The visit takes about an hour"
msgstr "La visita dura aproximadamente una hora"

#: src/routes/_app/messages/$id.tsx
msgid "This is a shared conversation - all members of your household can read and send messages"
msgstr "Esta es una conversación compartida - todos los miembros de su hogar pueden leer y enviar mensajes"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "This maintenance task is part of the Markku package. When you get the package, professionals will handle this task for you."
msgstr "Esta tarea de mantenimiento forma parte del paquete Markku. Cuando obtenga el paquete, los profesionales se encargarán de esta tarea por usted."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "This maintenance task is part of your Markku service agreement. Markku's professionals will handle this task for you according to the agreed schedule."
msgstr "Esta tarea de mantenimiento forma parte de su acuerdo de servicio Markku. Los profesionales de Markku se encargarán de esta tarea según el calendario acordado."

#: src/modules/consumption/ConsumptionModal.tsx
msgid "This will serve as the starting point. The next reading will show consumption."
msgstr "Esto servirá como punto de partida. La próxima lectura mostrará el consumo."

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
msgid "Time"
msgstr "Hora"

#: src/components/property/WelcomePropertyModal.tsx
msgid "To maintenance log"
msgstr "Al registro de mantenimiento"

#: src/routes/_app/visits/index.tsx
msgid "Today"
msgstr "Hoy"

#: src/routes/_app/visits/index.tsx
msgid "Tomorrow"
msgstr "Mañana"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Total"
msgstr "Total"

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "Total floor area"
msgstr "Superficie total"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Total paid"
msgstr "Total pagado"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Total to pay"
msgstr "Total a pagar"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Track annual maintenance"
msgstr "Seguimiento del mantenimiento anual"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Track your electricity, water, and heating consumption using meter readings."
msgstr "Haga seguimiento de su consumo de electricidad, agua y calefacción mediante las lecturas del contador."

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Tracking and summary"
msgstr "Seguimiento y resumen"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Type"
msgstr "Tipo"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Unfortunately, we do not yet serve your selected area."
msgstr "Lamentablemente, todavía no ofrecemos servicio en el área seleccionada."

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Unlock all features"
msgstr "Desbloquear todas las funciones"

#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Unnamed file"
msgstr "Archivo sin nombre"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Unpaid"
msgstr "Sin pagar"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Unpaid tasks:"
msgstr "Tareas sin pagar:"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Unpaid visit"
msgstr "Visita sin pagar"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Unpaid work:"
msgstr "Trabajo sin pagar:"

#: src/routes/_app/visits/$id.tsx
msgid "Upcoming visit"
msgstr "Próxima visita"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Upgrade to Markku service"
msgstr "Actualizar al servicio Markku"

#: src/modules/maintenance/Summary.tsx
msgid "Ventilation"
msgstr "Ventilación"

#: src/modules/visit/PastVisit/VisitNotesCard.tsx
msgid "Video summary"
msgstr "Resumen en vídeo"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
msgid "View all completed maintenance tasks"
msgstr "Ver todas las tareas de mantenimiento completadas"

#: src/modules/home/components/QuickActionsList.tsx
msgid "View maintenance history and tasks"
msgstr "Ver historial de mantenimiento y tareas"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "View property details"
msgstr "Ver detalles de la propiedad"

#: src/modules/home/components/UpcomingVisitCard.tsx
msgid "View visit details"
msgstr "Ver detalles de la visita"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Virtual barcode"
msgstr "Código de barras virtual"

#: src/modules/visit/FeedbackModal.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Visit"
msgstr "Visita"

#: src/modules/home/components/EngagementCard.tsx
msgid "Visit 28.4.2025 - Matti Meikäläinen"
msgstr "Visita 28.4.2025 - Matti Meikäläinen"

#: src/modules/visit/FutureVisit.tsx
msgid "Visit details"
msgstr "Detalles de la visita"

#: src/routes/_app/visits/index.tsx
msgid "Visit history"
msgstr "Historial de visitas"

#: src/routes/_app/visits/$id.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Visit not found"
msgstr "Visita no encontrada"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Visit partially paid"
msgstr "Visita parcialmente pagada"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Visit summary"
msgstr "Resumen de la visita"

#: src/config/navigation.tsx
#: src/routes/_app/visits/index.tsx
msgid "Visits"
msgstr "Visitas"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Voided"
msgstr "Anulada"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Warranties"
msgstr "Garantías"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Warranties, receipts and important documents safe in one place"
msgstr "Garantías, recibos y documentos importantes seguros en un solo lugar"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Warranty certificates and reminders"
msgstr "Certificados de garantía y recordatorios"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Water"
msgstr "Agua"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage doesn't choose a time. We are there when you need us."
msgstr "Los daños por agua no eligen momento. Estamos ahí cuando nos necesita."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency 24/7"
msgstr "Emergencia por daños de agua 24/7"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency help"
msgstr "Ayuda de emergencia por daños de agua"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency service included in all Markku packages"
msgstr "Servicio de emergencia por daños de agua incluido en todos los paquetes Markku"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Water leak"
msgstr "Fuga de agua"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "We are constantly expanding our service area!"
msgstr "¡Estamos ampliando constantemente nuestra área de servicio!"

#: src/modules/auth/OtpStep.tsx
msgid "We sent a 6-digit code to:"
msgstr "Hemos enviado un código de 6 dígitos a:"

#: src/routes/_app/messages/$id.tsx
msgid "We serve weekdays 8am-4pm"
msgstr "Atendemos de lunes a viernes de 8:00 a 16:00"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "We will book the survey visit with these details"
msgstr "Reservaremos la visita de inspección con estos datos"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "We will contact you before the visit using these details."
msgstr "Le contactaremos antes de la visita utilizando estos datos."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "We will contact you before the visit."
msgstr "Le contactaremos antes de la visita."

#: src/modules/auth/EmailStep.tsx
msgid "We will send a login code to your email"
msgstr "Le enviaremos un código de inicio de sesión a su correo electrónico"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "We will use these details to book your survey visit"
msgstr "Utilizaremos estos datos para reservar su visita de inspección"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Welcome to Markku maintenance book"
msgstr "Bienvenido al libro de mantenimiento Markku"

#: src/modules/auth/WelcomeStep.tsx
msgid "Welcome to Markku!"
msgstr "¡Bienvenido a Markku!"

#: src/modules/visit/FeedbackModal.tsx
msgid "What could be improved?"
msgstr "¿Qué se podría mejorar?"

#: src/modules/visit/FeedbackModal.tsx
msgid "What went well?"
msgstr "¿Qué salió bien?"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Where is the property located?"
msgstr "¿Dónde está ubicada la propiedad?"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Window cleaning"
msgstr "Limpieza de ventanas"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Winter"
msgstr "Invierno"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Winter tasks"
msgstr "Tareas de invierno"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "winter's"
msgstr "de invierno"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Wire transfer"
msgstr "Transferencia bancaria"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Wire transfer instructions"
msgstr "Instrucciones de transferencia"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "With the Markku package, you save {savedHours}h per year and {savedTasks} maintenance tasks"
msgstr "Con el paquete Markku, ahorra {savedHours}h al año y {savedTasks} tareas de mantenimiento"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Work completion date"
msgstr "Fecha de finalización del trabajo"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Year"
msgstr "Año"

#: src/modules/consumption/index.tsx
#: src/modules/consumption/index.tsx
msgid "Year {selectedYear} consumption"
msgstr "Consumo del año {selectedYear}"

#: src/modules/costs/CostsPage/index.tsx
#: src/modules/costs/CostsPage/index.tsx
msgid "Year {year} cost tracking"
msgstr "Seguimiento de costes del año {year}"

#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Year {year} summary"
msgstr "Resumen del año {year}"

#: src/routes/_app/maintenance.tsx
msgid "Year calendar"
msgstr "Calendario anual"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Year progress"
msgstr "Progreso del año"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "You can add an optional cost in euros if you also want to track your expenses"
msgstr "Puede añadir un coste opcional en euros si también desea hacer seguimiento de sus gastos"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "You can also add costs directly on this page using the \"Add\" button"
msgstr "También puede añadir costes directamente en esta página usando el botón \"Añadir\""

#: src/modules/subscription/components/PackageListSection.tsx
msgid "You can change to another package at any time."
msgstr "Puede cambiar a otro paquete en cualquier momento."

#: src/modules/auth/WelcomeStep.tsx
msgid "You must accept the terms of service to continue."
msgstr "Debe aceptar los términos de servicio para continuar."

#: src/modules/auth/WelcomeLogin.tsx
msgid "You must log in to continue."
msgstr "Debe iniciar sesión para continuar."

#: src/components/profile/NotificationSettings.tsx
msgid "You receive notifications on this device"
msgstr "Recibe notificaciones en este dispositivo"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskInfo.tsx
msgid "Your browser does not support the video tag."
msgstr "Su navegador no admite la etiqueta de vídeo."

#: src/modules/visit/FeedbackModal.tsx
msgid "Your feedback has been saved successfully."
msgstr "Sus comentarios se han guardado correctamente."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Your free survey visit has been booked"
msgstr "Su visita de inspección gratuita ha sido reservada"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Your maintenance log is now ready to use"
msgstr "Su registro de mantenimiento está listo para usar"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Your Markku package"
msgstr "Su paquete Markku"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Your property has been added!"
msgstr "¡Su propiedad ha sido añadida!"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Your property value is preserved"
msgstr "Se preserva el valor de su propiedad"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "Your selected time"
msgstr "Su hora seleccionada"
